import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import {
  periodColumnDefinition,
} from '../../shared/columnDefinitions';
import columnDefs from '../../shared/columnDefinitions/slAccountsPage';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default ({
  periodName,
  entities,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  const slAccountsWithPeriods = entities.map(slAccount => ({
    periodName,
    ...slAccount,
  }));

  const sheetData = [{
    name: 'BSM Account data',
    type: SheetExportTypes.GRID,
    columnDefinitions: [
      periodColumnDefinition,
      ...columnDefs,
    ],
    data: slAccountsWithPeriods,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Balance_Sheet_Management_Account_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
